const PhraseParentheses = ({ phrase, isStart, inGroup = false }) => {
  return (
    <>
      {isStart && (
        <>
          <div
            style={{
              position: "absolute",
              top: inGroup ? "-21px" : "1px",
              left: "10px",
              fontSize: "14px",
              width: "200px",
              color: phrase.color,
            }}
          >
            {phrase.text}
          </div>
          <span
            style={{
              marginTop: inGroup ? "0px" : "20px",
              color: phrase.color,
              fontWeight: "bold",
            }}
          >
            {phrase.type.includes("cls") ? "[" : "("}
          </span>
        </>
      )}
      {!isStart && (
        <span
          style={{
            marginTop: inGroup ? "0px" : "20px",
            color: phrase.color,
            fontWeight: "bold",
          }}
        >
          {phrase.type.includes("cls") ? "]" : ")"}
        </span>
      )}
    </>
  );
};

export default PhraseParentheses;
